import Vue from 'vue';
import store from '@/store';
import {MapActionsSnackbarModule} from "@/store/modules/snackbar/map-actions.snackbar";
import EnderecoModel from "@/models/cliente/endereco.model";
import DescricaoID from "@/models/lists/descricao-id.model";

class EnderecoService {

    STATUS_OK: number = 200;

    async cadastrar(body: EnderecoModel): Promise<any> {
        return await Vue.prototype.$axios.post('enderecos', body)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Endereço salvo com sucesso!');
                    const endereco: EnderecoModel = response.data;
                    return endereco;
                }
            })
            .catch((error: any) => {
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
                console.error(error.response);
            });
    }

    async atualizar(body: EnderecoModel): Promise<any> {
        return await Vue.prototype.$axios.put(`enderecos/${body.id}`, body)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_SUCCESS, 'Endereço atualizado com sucesso!');
                    const endereco: EnderecoModel = response.data;
                    return endereco;
                }
            })
            .catch((error: any) => {
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
                console.error(error.response);
            });
    }

    async buscarTodos(idCliente: number): Promise<any> {
        return await Vue.prototype.$axios.get(`enderecos/cliente/${idCliente}`)
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const lista: Array<EnderecoModel> = response.data;
                    return lista;
                } else {
                    store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, 'Falha inesperada ao carregar a lista de clientes');
                }
            })
            .catch((error: any) => {
                console.error(error.response);
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
            });
    }

    async getEstados(): Promise<any> {
        return await Vue.prototype.$axios.get('estados')
            .then((response: any) => {
                if (response.status === this.STATUS_OK) {
                    const lista: Array<DescricaoID> = response.data;
                    return lista;
                }
            })
            .catch((error: any) => {
                console.error(error.response);
                store.dispatch(MapActionsSnackbarModule.SET_SNACKBAR_ERROR, error.response.data);
            });
    }

}

export default new EnderecoService();
